import { render, staticRenderFns } from "./workFlowSettings.vue?vue&type=template&id=704a744c&scoped=true&"
import script from "./workFlowSettings.vue?vue&type=script&lang=js&"
export * from "./workFlowSettings.vue?vue&type=script&lang=js&"
import style0 from "./workFlowSettings.vue?vue&type=style&index=0&id=704a744c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704a744c",
  null
  
)

export default component.exports